import { CustomLoader } from "global/globalstyles";
import { ReactComponent as LogoIcon } from "assets/svgs/logo-icon.svg";
import React, { useEffect } from "react";
import * as motion from "motion/react-client";
import { PageLoaderDuration } from "provider";

export const LoaderScreen = () => {
  const [animationEnd, setAnimationEnd] = React.useState(false);
  const Delta = 1.8;
  useEffect(() => {
    setTimeout(() => {
      setAnimationEnd(true);
    }, PageLoaderDuration - Delta * 1000);
  }, []);
  return (
    <CustomLoader>
      <div className="backdrop"></div>
      <div className="loader-bg">
        <div
          className={
            !animationEnd ? "logo-loader animate" : "logo-loader  "
          }
        >
          <motion.div
            initial={{ opacity: 1, scale: 1 }}
            animate={{ opacity: 0.0, scale: 10 }}
            transition={{
              duration: 1.0001,
              delay: PageLoaderDuration / 1000 - 1,
              ease: ["easeIn", "easeOut"],
            }}
          >
              <LogoIcon />
          </motion.div>
          {/* <div className="animate-ctn">
            <span></span>
            <span></span>
            <LogoIcon />
          </div> */}
        </div>
      </div>
    </CustomLoader>
  );
};
